import CreateOrderPage from '@/pages/shared/CreateOrderPage'

export default function AdminCreateOrder() {
  return <CreateOrderPage basePath="/admin" canChoosePic canBypassQuota canOrderOnCredit canAgreePrice />
}
